import { apiCatalogProvider } from "./apiCatalogProvider";
import { mockCatalogProvider } from "./mockCatalogProvider";
import { isMockEnabled } from "../../../config/featureConfig";

export const catalogProvider = isMockEnabled("catalog")
  ? mockCatalogProvider
  : apiCatalogProvider;



